import { render, staticRenderFns } from "./side-article-landing.vue?vue&type=template&id=796dfafa&"
import script from "./side-article-landing.vue?vue&type=script&lang=js&"
export * from "./side-article-landing.vue?vue&type=script&lang=js&"
import style0 from "./side-article-landing.vue?vue&type=style&index=0&id=796dfafa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports